export default "__VITE_ASSET__C1Q$vcLB__"